import { Component } from "react";
import ServicioAutorizaciones from "../../../servicios/Autorizaciones";
import SolicitudDetalleAutorizacion from "../../../Contenedores/Autorizaciones/SolicitudDetalleAutorizacion";
import { CerrarNotificador, Notificar } from "../../Comunes/Notificador";
import moment from "moment";
import PersonaFisica from "../Personas/PersonaFisica";
import PersonaJuridica from "../Personas/PersonaJuridica";
import IdentificacionesAsociadas from "../../Comunes/IdentificacionesAsociadas/IdentificacionesAsociadas";
import DatosUsuario from "../../Comunes/DatosUsuario/DatosUsuario";
import DocumentosAutorizacion from "../../Comunes/Documentos/DocumentosAutorizacion";
import { _VerificarArray, __EsPersonaFisica } from "../../../Utils/Funciones";
import servicioUsuario from "../../../servicios/servicioUsuario";
import { nombreDeRol } from "../../../constantes/nombreDeRol";
import RevocarAutorizacionModal from "./RevocarAutorizacionModal";
import EliminarAutorizacionModal from "./EliminarAutorizacionModal";
import { TIPOAUTORIZACION } from "../../../Contenedores/Comun/VARIABLES";
import StickyTopBox from "../../Comunes/StickyBox/StickyTopBox";

export default class DetalleAutorizacion extends Component {
  constructor(props) {
    super(props);

    this.state = {
      EstadoAutorizacion: 0,
      EstaFinalizadaAutorizacion: false,
      TipoAutorizacion: 0,
      DatosDetalle: [],
      EsPersonaFisica: false,
      DatosPersona: [],
      DatosPersonaRepLegal: [],
      identificacionesAsociadas: null,
      UsuarioTramite: [],
      Documentos: [],
      RenderizarDetalle: false,
    };
  }

  async componentDidMount() {
    await this.consultaDetalleAutorizacion();
  }

  async consultaDetalleAutorizacion() {
    let datos = this.props.DatosAutorizacion;

    let parametro = new SolicitudDetalleAutorizacion();
    parametro.NumeroAutorizacion = datos.numeroAutorizacion;
    parametro.TipoAutorizacion = datos.tipoAutorizacion.codigo;
    parametro.EntidadAutorizada = datos.entidadAutorizada.id;

    let detalle = await ServicioAutorizaciones.ObtengaDetalleAutorizacion(
      parametro
    );

    if (detalle.esValido) {
      CerrarNotificador();
      await this.cargarDatosParaDetalleAutorizacion(detalle);
    } else {
      Notificar("error", detalle.errores);
    }
  }

  async cargarDatosParaDetalleAutorizacion(datos) {
    let estado = parseInt(datos.estadoAutorizacion.codigo);
    let estafinalizada = datos.finRelacionCrediticia == null ? false : true;
    let tipoAutorizacion = datos.tipoAutorizacion.Codigo;
    let espersonafisica = await __EsPersonaFisica(
      datos.datosPersona.identificacionPrincipal.tipoPersona.codigo
    );
    let Persona = datos.datosPersona;
    let PersonaRepLegal = datos.representanteLegal;
    let asociadas = espersonafisica
      ? _VerificarArray(datos.datosPersona?.identificacionesAsociadas)
      : _VerificarArray(datos.representanteLegal?.identificacionesAsociadas);
    let usuarioTramite = datos.datosUsuario;
    let documentos = _VerificarArray(datos.documentos);

    this.setState({
      EstadoAutorizacion: estado,
      EstaFinalizadaAutorizacion: estafinalizada,
      TipoAutorizacion: tipoAutorizacion,
      DatosDetalle: datos,
      EsPersonaFisica: espersonafisica,
      DatosPersona: Persona,
      DatosPersonaRepLegal: PersonaRepLegal,
      identificacionesAsociadas: asociadas,
      UsuarioTramite: usuarioTramite,
      Documentos: documentos,
      RenderizarDetalle: true,
    });
  }

  render() {
    return (
      <div>
        <StickyTopBox>
          <div className="row">
            <div className="col-auto">
              <button
                type="button"
                onClick={() => this.props.VolverAResultados()}
                className="btn btn-sm btn-primary"
              >
                <i className="fas fa-arrow-circle-left"></i>
              </button>
            </div>

            <div className="col">
              <h1 className="h3 mb-0 text-gray-800">
                Detalle de la Autorización
              </h1>
            </div>

            <div className="col text-right">
              {servicioUsuario.tieneRol(nombreDeRol.AutorizacionEliminar) &&
              this.props.DatosAutorizacion?.tipoAutorizacion?.codigo ===
                TIPOAUTORIZACION.ESPECIFICA ? (
                <EliminarAutorizacionModal
                  datosAutorizacion={this.state.DatosDetalle}
                  VolverAResultados={this.props.VolverAResultados}
                />
              ) : null}

              {servicioUsuario.tieneRol(nombreDeRol.AutorizacionRevocar) &&
              this.props.DatosAutorizacion?.tipoAutorizacion?.codigo ===
                TIPOAUTORIZACION.ESPECIFICA ? (
                <RevocarAutorizacionModal
                  datosAutorizacion={this.state.DatosDetalle}
                  VolverAResultados={this.props.VolverAResultados}
                />
              ) : null}
            </div>
          </div>
        </StickyTopBox>

        {this.state.RenderizarDetalle ? (
          <div>
            <div id="MostrarDatosPersonaFisicaoJuridica">
              {this.state.EsPersonaFisica ? (
                <PersonaFisica DatosPersonaFisica={this.state.DatosPersona} />
              ) : (
                <div>
                  <PersonaJuridica PersonaJuridica={this.state.DatosPersona} />
                  <PersonaFisica
                    DatosPersonaFisica={this.state.DatosPersonaRepLegal}
                    Titulo={"Datos del Representante Legal"}
                  />
                </div>
              )}
            </div>

            <div id="identificacionesAsociadas">
              {this.state.identificacionesAsociadas != null ? (
                <IdentificacionesAsociadas
                  Identificaciones={this.state.identificacionesAsociadas}
                  Titulo={
                    this.state.EsPersonaFisica
                      ? "Identificaciones Asociadas"
                      : "Identificaciones Asociadas Representante Legal"
                  }
                />
              ) : null}
            </div>

            <div className="card shadow mb-4">
              <div className="card-header">
                <h6 className="m-0 font-weight-bold text-primary">
                  Datos de la Autorización
                </h6>
              </div>
              <div className="card-body text-gray-800">
                <div className="form-row">
                  <div className=" form-group col-md-4">
                    <label
                      id="lblNumAutorizacion"
                      htmlFor="numAutorizacion"
                      className="col-form-label"
                    >
                      Número de Autorización
                    </label>
                    <input
                      type="hidden"
                      id="numAutorizacion"
                      value={this.state.DatosDetalle.numeroAutorizacion}
                      readOnly
                    />
                    <input
                      type="text"
                      id="NumeroAutorizacionFormateado"
                      value={
                        this.state.DatosDetalle.numeroAutorizacionFormateado
                      }
                      className="form-control"
                      readOnly
                    />
                  </div>

                  <div className="form-group col-md-4">
                    <label
                      id="lblEntidadAutorizada"
                      htmlFor="entidadAutorizada"
                      className="col-form-label"
                    >
                      Entidad Autorizada
                    </label>
                    <input
                      type="hidden"
                      id="EntidadAutorizada.Id"
                      value={this.state.DatosDetalle.entidadAutorizada.id}
                      readOnly
                    />
                    <input
                      type="text"
                      id="EntidadAutorizada.Alias"
                      value={this.state.DatosDetalle.entidadAutorizada.alias}
                      className="form-control"
                      readOnly
                    />
                  </div>
                  <div className="form-group col-md-4">
                    <label
                      id="lblTipoAutorizacion"
                      htmlFor="tipoAutorizacion"
                      className="col-form-label"
                    >
                      Tipo Autorización
                    </label>
                    <input
                      type="hidden"
                      id="CodigoTipoAutorizacion"
                      value={this.state.DatosDetalle.tipoAutorizacion.codigo}
                      readOnly
                    />
                    <input
                      type="text"
                      id="tipoAutorizacion"
                      value={
                        this.state.DatosDetalle.tipoAutorizacion.descripcion
                      }
                      className="form-control"
                      readOnly
                    />
                  </div>

                  <div className="form-group col-md-4">
                    <label
                      id="lblEstado"
                      htmlFor="DescripcionEstado"
                      className="col-form-label"
                    >
                      Estado
                    </label>
                    <input
                      type="hidden"
                      id="C_Estado_Autorizacion"
                      value={this.state.DatosDetalle.estadoAutorizacion.codigo}
                      readOnly
                    />
                    <input
                      type="text"
                      id="DescripcionEstado"
                      value={
                        this.state.DatosDetalle.estadoAutorizacion.descripcion
                      }
                      className="form-control"
                      readOnly
                    />
                  </div>

                  <div className="form-group col-md-4">
                    <label
                      id="lblFecha"
                      htmlFor="FechaTramite"
                      className="col-form-label"
                    >
                      Fecha de Trámite:{" "}
                    </label>
                    <input
                      type="datetime"
                      name="FechaTramite"
                      id="FechaTramite"
                      value={
                        this.state.DatosDetalle.fechaTramite == null
                          ? ""
                          : moment(this.state.DatosDetalle.fechaTramite).format(
                              "DD/MM/YYYY hh:mm A"
                            )
                      }
                      className="form-control"
                      readOnly
                    />
                  </div>

                  <div className="form-group col-md-4">
                    <label
                      id="lblFecha"
                      htmlFor="TxtfechaVencimiento"
                      className="col-form-label"
                    >
                      Fecha de Vencimiento:{" "}
                    </label>
                    <input
                      type="datetime"
                      name="TxtfechaVencimiento"
                      id="TxtfechaVencimiento"
                      value={
                        this.state.DatosDetalle.finRelacionCrediticia == null
                          ? ""
                          : moment(
                              this.state.DatosDetalle.finRelacionCrediticia
                            ).format("DD/MM/YYYY")
                      }
                      className="form-control"
                      readOnly
                    />
                  </div>
                </div>
              </div>
            </div>

            <div id="DatosUsuarioTramite">
              {
                <DatosUsuario
                  Usuario={this.state.UsuarioTramite}
                  Titulo={"Datos del Usuario que Registró la Autorización "}
                />
              }
            </div>

            <div>
              {this.state.Documentos != null ? (
                <DocumentosAutorizacion documentos={this.state.Documentos} />
              ) : null}
            </div>
          </div>
        ) : null}
      </div>
    );
  }
}
